module.exports = __webpack_public_path__ + "static/media/login_banner.cf54d007.jpg";